var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section", attrs: { id: "firmador" } }, [
    !_vm.noDocs
      ? _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-6 is-offset-3 has-text-centered" },
            [
              !_vm.firmadorSelected
                ? _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-content" }, [
                      _c("h1", { staticClass: "subtitle is-5" }, [
                        _vm._v("Paso 1"),
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "title is-4 animated flash" }, [
                        _vm._v("Seleccione el firmador"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "columns" }, [
                        _vm.user.firmadores_habilitados.signar
                          ? _c(
                              "div",
                              { staticClass: "column has-text-centered" },
                              [
                                _c("img", {
                                  staticClass: "image firmador-select",
                                  attrs: {
                                    src: "/statics/signar-logo.svg",
                                    alt: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitPila("signar")
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.firmadores_habilitados.pfdrar
                          ? _c(
                              "div",
                              { staticClass: "column has-text-centered" },
                              [
                                _c("img", {
                                  staticClass: "image firmador-select",
                                  attrs: {
                                    src: "/statics/pfdrar-logo.png",
                                    alt: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitPila("pfdrar")
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ])
                : _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-content" }, [
                      _c("h1", { staticClass: "subtitle is-5" }, [
                        _vm._v("Paso 2"),
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "title is-3 animated flash" }, [
                        _vm._v("Abriendo firmador"),
                      ]),
                      _vm._v(" "),
                      _vm.firmadorSelected === "signar"
                        ? _c("h1", { staticClass: "subtitle is-5" }, [
                            _vm._v("Signar ®"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.firmadorSelected === "pfdrar"
                        ? _c("h1", { staticClass: "subtitle is-6" }, [
                            _vm._v(
                              "Plataforma de Firma Digital Remota - Secretaria de Modernización - Argentina"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.firmadorSelected === "signar"
                        ? _c("img", {
                            staticClass: "image",
                            attrs: {
                              src: "/statics/signar-logo.svg",
                              alt: "Signar Firmador - By Lyris",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.firmadorSelected === "pfdrar"
                        ? _c("img", {
                            staticClass: "image",
                            attrs: {
                              src: "/statics/pfdrar-logo.png",
                              alt: "Plataforma de firma digital remota - Argentina",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _c("p", { staticClass: "has-text-info" }, [
                          _vm._v("NOTA: Si el firmador\n              "),
                          _c("u", [_vm._v("NO")]),
                          _vm._v(
                            " se ejecutó, verifique si su navegador está bloqueando los pop-ups "
                          ),
                          _vm.firmadorSelected === "signar"
                            ? _c("span", [
                                _vm._v("y "),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.firmarSignar(_vm.urlSignar)
                                      },
                                    },
                                  },
                                  [_c("u", [_vm._v("haga click aquí")])]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Recomendamos habilitar los pop-ups para esta página.\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.firmadorSelected === "signar"
                          ? _c("p", [
                              _vm._v("¿No cuenta con Signar® Firmador?   "),
                              _vm._m(0),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.firmadorSelected === "signar"
                          ? _c("p", { staticClass: "is-size-7" }, [
                              _vm._v(
                                "Si desea, puede utilizar al versión legacy (JNLP) "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: this.urlJnlp,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("haciendo clic aquí")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button is-dark",
                          on: { click: _vm.goBack },
                        },
                        [
                          _c("i", { staticClass: "fas fa-reply" }),
                          _vm._v(" Volver\n          "),
                        ]
                      ),
                    ]),
                  ]),
              _vm._v(" "),
              _vm.firmadorSelected && _vm.postergados
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-content has-text-centered" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("p", { staticClass: "subtitle is-6" }, [
                          _vm._v(
                            'Para firmar los documentos pendientes, haga clic en "Continuar"'
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "a",
                            {
                              staticClass: "button is-info",
                              on: { click: _vm.continuarPostergados },
                            },
                            [
                              _vm._v("\n            Continuar "),
                              _c("i", { staticClass: "fas arrow-right" }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.docStack.length > 0
            ? _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "box" }, [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          _vm.showTable = !_vm.showTable
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-lg is-pulled-right",
                        class: _vm.angle,
                      }),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass: "subtitle is-5",
                          class: { "is-marginless": !_vm.showTable },
                        },
                        [
                          _vm._v("Documentos a firmar "),
                          _c("small", [
                            _vm._v("(" + _vm._s(_vm.docStack.length) + ")"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showTable,
                          expression: "showTable",
                        },
                      ],
                      staticClass: "content",
                    },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c("table", { staticClass: "table" }, [
                        _c(
                          "tbody",
                          _vm._l(_vm.docStack, function (doc) {
                            return _c(
                              "tr",
                              { key: doc.id, attrs: { title: doc.nombre } },
                              [
                                _c("td", { staticClass: "is-size-7" }, [
                                  doc.tipo_documento_id == "carpeta"
                                    ? _c("i", { staticClass: "fas fa-folder" })
                                    : doc.tipo_documento_id == "recibo"
                                    ? _c("i", {
                                        staticClass: "fas fa-dollar-sign",
                                      })
                                    : _c("i", { staticClass: "fas fa-file" }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(doc.nombre) +
                                      "\n          "
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-6 is-offset-3 has-text-centered" },
            [
              _c("h1", { staticClass: "title is-3" }, [
                _vm._v("La pila de documentos está vacia"),
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "subtitle is-6" }, [
                _vm._v("Para poder firmar debe haber documentos en pila"),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "button is-dark", attrs: { to: "/" } },
                [
                  _c("i", { staticClass: "fas fa-reply fa-fw" }),
                  _vm._v(" Volver al inicio\n      "),
                ]
              ),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "https://firmador.lyris.com.ar" } }, [
      _c("i", { staticClass: "fas fa-download" }),
      _vm._v(" Descárguelo aquí"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "title has-text-primary is-5" }, [
      _c("i", { staticClass: "fas fa-exclamation-triangle" }),
      _vm._v(" Existen documentos pendientes por firmar"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }